import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRfiCmsData } from '@Redux/selectors';
import { CenterContainer, LoaderImage, LoadingContainerDetails } from './styles';
import { LOADING_SCREEN, Screens } from './utils';
import { AppDispatch } from '../../store.type';
import { remitterPersonalInfo } from '@Redux/actions/user-status/user-status-action';
import { APPROVED } from '@Utils/constants';
import { Transition } from 'semantic-ui-react';
import { LOADER_ICON } from '@Images';
import { LoadingPageProps } from './types';

const LoadingPage: React.FC<LoadingPageProps> = (props) => {
  const loadingPageCMSData = useSelector(getRfiCmsData)?.ekycRFI?.loadingPage;
  const { changeScreen } = props;
  const { heading, description, loadingTime } = loadingPageCMSData ?? LOADING_SCREEN;

  const dispatch = useDispatch<AppDispatch>();

  const fetchPersonalInfo = async () => {
    const remitterInfo = await dispatch(remitterPersonalInfo());
    if (remitterInfo?.data?.data?.status === APPROVED) changeScreen(Screens.success);
    else changeScreen(Screens.pending);
  };

  useEffect(() => {
    setTimeout(fetchPersonalInfo, loadingTime);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CenterContainer>
      <div className="innerContainer">
        <Transition visible={true} duration={300}>
          <LoaderImage src={LOADER_ICON} alt="loader" />
        </Transition>
        <LoadingContainerDetails>
          <p className="heading">{heading}</p>
          <p className="description">{description}</p>
        </LoadingContainerDetails>
      </div>
    </CenterContainer>
  );
};

export default LoadingPage;
